import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Dropdown, Menu} from 'semantic-ui-react';
import PropTypes from 'prop-types';
import {Translate} from 'react-localize-redux';

import {getUser, isLoggedIn} from "../../../../reducer";
import {Link} from 'react-router-dom';


class ProfileLink extends Component {

    render() {

        if (this.props.loggedIn) {
            if (this.props.mobile) {
                return (
                    <Translate>
                        {({translate}) =>
                            <Menu.Item>
                                <Menu.Header>{this.props.user.name}</Menu.Header>
                                <Menu.Menu>
                                    <Menu.Item name={translate('general.settings')} as={Link} to={'/profile/settings'}/>
                                </Menu.Menu>
                            </Menu.Item>
                        }
                    </Translate>
                );
            }
            return (
                <Translate>
                    {
                        ({translate}) =>
                            <Dropdown item text={translate('general.profile')}>
                                <Dropdown.Menu>
                                    <Dropdown.Header as={Link} to={'/profile/settings'}>{this.props.user.name}</Dropdown.Header>
                                    <Dropdown.Item as={Link} to={'/profile/settings'}>{translate('general.settings')}</Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                    }
                </Translate>
            );
        }

        return null;
    }
}

ProfileLink.contextTypes = {
    router: PropTypes.object
};


const mapStateToProps = state => ({
    loggedIn: isLoggedIn(state),
    user: getUser(state)
});


export default connect(
    mapStateToProps,
    null,
    null
)(ProfileLink)



// WEBPACK FOOTER //
// ./src/components/Homepage/components/ProfileLink/index.js